import * as Types from '../../../generated/gqlTypes';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type AuthorizationKeyListQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type AuthorizationKeyListQuery = { authorizationKeyList: Array<{ id: string, name: string, key: string }> };


export const AuthorizationKeyListDocument = gql`
    query AuthorizationKeyList {
  authorizationKeyList {
    id
    name
    key
  }
}
    `;

/**
 * __useAuthorizationKeyListQuery__
 *
 * To run a query within a React component, call `useAuthorizationKeyListQuery` and pass it any options that fit your needs.
 * When your component renders, `useAuthorizationKeyListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAuthorizationKeyListQuery({
 *   variables: {
 *   },
 * });
 */
export function useAuthorizationKeyListQuery(baseOptions?: Apollo.QueryHookOptions<AuthorizationKeyListQuery, AuthorizationKeyListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AuthorizationKeyListQuery, AuthorizationKeyListQueryVariables>(AuthorizationKeyListDocument, options);
      }
export function useAuthorizationKeyListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AuthorizationKeyListQuery, AuthorizationKeyListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AuthorizationKeyListQuery, AuthorizationKeyListQueryVariables>(AuthorizationKeyListDocument, options);
        }
export type AuthorizationKeyListQueryHookResult = ReturnType<typeof useAuthorizationKeyListQuery>;
export type AuthorizationKeyListLazyQueryHookResult = ReturnType<typeof useAuthorizationKeyListLazyQuery>;
export type AuthorizationKeyListQueryResult = Apollo.QueryResult<AuthorizationKeyListQuery, AuthorizationKeyListQueryVariables>;
export function refetchAuthorizationKeyListQuery(variables?: AuthorizationKeyListQueryVariables) {
      return { query: AuthorizationKeyListDocument, variables: variables }
    }